import React from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { companyInfo } from '../../data/mock';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const navItems = [
    { name: 'About', to: 'about' },
    { name: 'Services', to: 'services' },
    { name: 'Industries', to: 'industries' },
    { name: 'Clients', to: 'clients' },
    { name: 'Team', to: 'team' },
    { name: 'Contact', to: 'contact' }
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#0B1F33]/95 backdrop-blur-md border-b border-[rgba(91,181,197,0.1)]">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo with subtle light background only behind it */}
          <Link to="/" className="flex items-center gap-3">
            <div className="bg-white/90 rounded-md px-2 py-1">
              <img 
                src="/logo-transparent.png" 
                alt="IJSS IT Solutions"
                className="h-9 lg:h-10 w-auto object-contain"
              />
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-1">
            {isHomePage ? (
              navItems.map((item) => (
                <ScrollLink
                  key={item.name}
                  to={item.to}
                  spy={true}
                  smooth={true}
                  offset={-80}
                  duration={500}
                  className="cursor-pointer px-4 py-2 text-sm font-medium text-[#A8B5C4] hover:text-[#5BB5C5] transition-colors"
                >
                  {item.name}
                </ScrollLink>
              ))
            ) : (
              navItems.map((item) => (
                <Link
                  key={item.name}
                  to={`/#${item.to}`}
                  className="px-4 py-2 text-sm font-medium text-[#A8B5C4] hover:text-[#5BB5C5] transition-colors"
                >
                  {item.name}
                </Link>
              ))
            )}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:block">
            {isHomePage ? (
              <ScrollLink
                to="contact"
                spy={true}
                smooth={true}
                offset={-80}
                duration={500}
                className="btn-primary cursor-pointer text-sm"
              >
                Contact Us
              </ScrollLink>
            ) : (
              <Link to="/#contact" className="btn-primary text-sm">
                Contact Us
              </Link>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden text-white p-2"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-[rgba(91,181,197,0.1)]">
            <nav className="flex flex-col gap-1">
              {isHomePage ? (
                navItems.map((item) => (
                  <ScrollLink
                    key={item.name}
                    to={item.to}
                    spy={true}
                    smooth={true}
                    offset={-80}
                    duration={500}
                    className="nav-link py-3"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item.name}
                  </ScrollLink>
                ))
              ) : (
                navItems.map((item) => (
                  <Link
                    key={item.name}
                    to={`/#${item.to}`}
                    className="nav-link py-3"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item.name}
                  </Link>
                ))
              )}
              <div className="pt-4">
                {isHomePage ? (
                  <ScrollLink
                    to="contact"
                    spy={true}
                    smooth={true}
                    offset={-80}
                    duration={500}
                    className="btn-primary w-full text-center"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Contact Us
                  </ScrollLink>
                ) : (
                  <Link
                    to="/#contact"
                    className="btn-primary w-full text-center"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Contact Us
                  </Link>
                )}
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
